import React from 'react';
import {Box} from 'reactjs-admin-lte';
import FontAwsome from 'react-fontawesome';
import {Col, Row} from 'react-bootstrap';

export default ({loading = true, driver = {},owner={}}) => {
  return (<div>
    <Box loading={loading}>
      <Box.Header>
        <Box.Title border={true}>
          <FontAwsome className="text-blue"
                      name="user" /> รายละเอียดผู้ครอบครอง
        </Box.Title>
      </Box.Header>
      <Box.Body>

        {/*Row 1*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ชื่อผู้ครอบครอง</label>
          </Col>
          <Col sm={1}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
          <Col sm={3}>
            <input className="form-control" disabled
                   value={owner.name} />
          </Col>
          <Col sm={2}>
            <label className="control-label">เลขบัตรประจำตัว</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={owner.identity_no} />
          </Col>
        </Row>


        {/*Row 2*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">เลขที่ใบขับขี่</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={owner.driver_license_no} />
          </Col>
          <Col sm={2}>
            <label className="control-label">หมายเลขโทรศัพท์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={owner.tel} />
          </Col>
        </Row>

        {/*Row 3*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ที่อยู่</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
          <Col sm={2}>
            <label className="control-label">เบอร์ติดต่ออื่น</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
        </Row>

        {/*Row 4*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">จังหวัด</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
        </Row>

        {/*Row 5*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">รหัสไปรษณีย์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
        </Row>
      </Box.Body>
    </Box>

    <Box loading={loading}>
      <Box.Header>
        <Box.Title border={true}>
          <FontAwsome className="text-blue"
                      name="user" /> รายละเอียดผู้ขับขี่
        </Box.Title>
      </Box.Header>
      <Box.Body>

        {/*Row 1*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ชื่อผู้ขับขี่</label>
          </Col>
          <Col sm={1}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
          <Col sm={3}>
            <input className="form-control" disabled
                   value={driver.name} />
          </Col>
          <Col sm={2}>
            <label className="control-label">เลขบัตรประจำตัว</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.identity_no} />
          </Col>
        </Row>


        {/*Row 2*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">เลขที่ใบขับขี่</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.driver_license_no} />
          </Col>
          <Col sm={2}>
            <label className="control-label">หมายเลขโทรศัพท์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.tel} />
          </Col>
        </Row>

        {/*Row 3*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">ที่อยู่</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.address} />
          </Col>
          <Col sm={2}>
            <label className="control-label">เบอร์ติดต่ออื่น</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.other_tel} />
          </Col>
        </Row>

        {/*Row 4*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">จังหวัด</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={driver.address_province} />
          </Col>
        </Row>

        {/*Row 5*/}
        <Row className="form-group">
          <Col sm={2}>
            <label className="control-label">รหัสไปรษณีย์</label>
          </Col>
          <Col sm={4}>
            <input className="form-control" disabled
                   value={''} />
          </Col>
        </Row>
      </Box.Body>
    </Box>
  </div>);
};


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/components/PreviewOwner.js